import type { ReactElement } from "react";
import MenuItem, { type IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";
import { useMatrixFilteredMenuItems } from "@Front/Components/DesignSystem/Menu/useMatrixFilteredMenuItems";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";
import { useOfficeMenuMatrixCan } from "../../../hooks/useOfficeMenuMatrixCan";

type OfficeMenuSectionProps = {
	officeMenuCandidates: IItem[];
	isSuperAdmin: boolean;
	superAdminItems: IItem[];
};

export function OfficeMenuSection(props: OfficeMenuSectionProps): ReactElement {
	const { officeMenuCandidates, isSuperAdmin, superAdminItems } = props;
	const menuLabels = COMMON_UI_I18N.navigationMenu.common;
	const officeMatrixCan = useOfficeMenuMatrixCan();
	const { effectiveItems: officeItemsForDropdown } = useMatrixFilteredMenuItems(officeMenuCandidates, officeMatrixCan);

	return (
		<>
			{isSuperAdmin && (
				<MenuItem
					item={{
						text: menuLabels.workspaceSuperAdmin,
						dropdown: {
							items: superAdminItems,
						},
					}}
				/>
			)}

			{officeItemsForDropdown.length > 0 && (
				<MenuItem
					item={{
						text: menuLabels.workspaceOffice,
						hasSeparator: true,
						dropdown: {
							items: officeItemsForDropdown,
						},
					}}
				/>
			)}
		</>
	);
}
